import { InfoIcon } from '@carboncopyco/icons';
import { ColorHex, MessageBox, TextCaption } from '@carboncopyco/ui';
import { useContext } from 'react';
import { RulesManagerContext } from './RulesManagerContext';

export interface ManagerMessageBoxProps {
  linkUrl: string;
}

export const ManagerMessageBox = ({
  linkUrl = 'https://demostack.com',
}: ManagerMessageBoxProps) => {
  const { onLearnMoreClick } = useContext(RulesManagerContext);
  return (
    <div className="mt-5 mb-5">
      <MessageBox
        warn
        border
        fullHeight
        label={
          <>
            <span className="mr-2 h-full">
              <InfoIcon
                size={16}
                color={ColorHex.secondary500}
              />
            </span>
            <div className="text-ds-200 tracking-ds-tight leading-ds-200">
              <TextCaption
                color="text-ds-secondary-500"
                label="Demostack does not validate or debug custom snippets. "
              />
              <a
                href={linkUrl}
                target="_blank"
                rel="noreferrer"
                onClick={(e) => {
                  if (onLearnMoreClick) {
                    e.preventDefault();
                    onLearnMoreClick(linkUrl);
                  }
                }}
              >
                <TextCaption
                  underline
                  label="Learn more"
                  color="text-ds-secondary-500"
                />
              </a>
            </div>
          </>
        }
      />
    </div>
  );
};
